declare var $: any;
//system
import { Component, Input, OnInit, Output, EventEmitter, OnDestroy, AfterViewInit, ElementRef, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

//services
import { LogService } from 'src/app/services/common/log.service';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { FacilityService } from 'src/app/services/facility.service';
import { EnvironmentService } from 'src/app/services/environment.service';

//components
import { AuthBaseComponent } from 'src/app/components/auth-base/auth-base.component';

//interfaces
import { CurrencyMeta, Pack, MenuPack } from 'src/app/models/meta';
import { MemberCurrency, Purchase, MyDrop, Booking } from 'src/app/models/member';
import { TermUnit, CurrencyMenuPackState, MembershipAction, StartRule } from 'src/app/models/enums';

//utils
import { Utils } from 'src/app/services/common/utils';
import { CheckoutComponentFactoryService } from 'src/app/services/checkoutComponentFactoryService';
import { upgradeTimeStartCalendarDate } from '../membership-transition.helpers';

@Component({
  selector: 'df-upgrade-time',
  templateUrl: './upgrade-time.component.html',
  styleUrls: ['./upgrade-time.component.scss']
})
export class UpgradeTimeComponent extends AuthBaseComponent implements OnInit, OnDestroy, AfterViewInit {
  
  private readonly _unsubscribe: Subject<any> = new Subject();
  @Input() public currencyMeta! : CurrencyMeta;
  @Input() public purchase! : Purchase;
  @Input() public myDrop! : MyDrop;
  @Output() passEntry:      EventEmitter<boolean> = new EventEmitter();
  submitted:                boolean  = false;
  initialized:              boolean  = false;
  memberCurrency!:          MemberCurrency;
  subscriptionMenuIds!:     number[];
  filteredMenuPacks!:       MenuPack[];
  pack!:                    Pack | undefined;
  modalBodyHeight:          number = 0;
  planMenuPacks:            MenuPack[] = [];
  selectedMenuPack: MenuPack = UpgradeTimeComponent.getDefaultMenuPack();
  static getDefaultMenuPack(): MenuPack {
    return {
      Id: 0,
      Name: "",
      NameOverride: false,
      MenuId: 0,
      CategoryId: null,
      CurrencyId: 0,
      PackId: 0,
      Order: 0,
      IsSubscription: false,
      DiscountedPrice: 0,
      Price: 0,
      DecoyPrice: 0,
      TermDuration: 0,
      TermUnit: TermUnit.Unset,
      CycleDuration: 0,
      CyclePeriod: TermUnit.Unset,
      ExtraCycleCount: 0,
      DiscountedTermDuration: 0,
      DiscountedTermUnit: TermUnit.Unset,
      Badge: "",
      State: CurrencyMenuPackState.Unset,
      PriceString: "",
      DiscountedPriceString: "",
      DecoyPriceString: "",
      TaxPrice: 0,
      TotalPrice: 0,
      IsPausable: false,
      ParentId: 0,
      UpgradeDescription: "",
      LastModified: new Date(),
      LastModifiedBy: "",
      CreatedAt: new Date(),
      CreatedBy: "",
      Guid: "",
      PurchaseOffset: 0,
      PurchaseRule: StartRule.Unset,
      StartOffset: 0,
      StartRule: StartRule.Unset,
      IsTrialPack: false,
      TrialRewardTriggerType: 0,
      DocumentId: null,
      Pack: {
        Id: 0,
        Guid: "",
        Name: "",
        Description: "",
        CurrencyId: 0,
        Quantity: 0,
        IsTaxable: false,
        IsUnlimited: false,
        TaxCategoryId: null,
        TaxCategory: {
          Id: 0,
          Guid: "",
          Name: "",
          LastModified: new Date(),
          LastModifiedBy: "",
          CreatedAt: new Date(),
          CreatedBy: ""
        },
        Image: "",
        Benefits: [],
        LastModified: new Date(),
        LastModifiedBy: "",
        CreatedAt: new Date(),
        CreatedBy: ""
      }
    };
  }
  selectedMenuPackId:       number = 0;
  selectedUpgradeNow:       boolean = true;
  selectedUpgradeNowStr:    string = "true";
  currentMember!:           any;
  memberId:                 number = 0;
  nextChargableDate:        string = '';
  checkoutComponent:        any;

  constructor(
    private router: Router
    , private logService: LogService
    , private alertService: AlertService
    , private facilityService: FacilityService
    , public activeModal: NgbActiveModal
    , private authService: AuthService
    , private modalService: NgbModal
    , private elRef: ElementRef
    , private renderer: Renderer2
    , private CheckoutComponentFactoryService: CheckoutComponentFactoryService
    , private environmentService: EnvironmentService
  ) {
    super(router, logService, alertService, facilityService);
    this.checkoutComponent = this.CheckoutComponentFactoryService.getCheckoutComponent();
  }

  override async ngOnInit() {
    await super.ngOnInit();
  this.selectedMenuPack = UpgradeTimeComponent.getDefaultMenuPack();

    this.currentMember = this.authService.getLoggedInMember();
    this.memberId = this.currentMember?.Id || 0;
    
    const filteredMenuPackIds = this.currencyMeta.DiscountMenuPacks.map(dmp => dmp.MenuPackId);
    this.subscriptionMenuIds = this.currencyMeta.Menus.filter(m => m.IsSubscription).map(m => m.Id);
    this.filteredMenuPacks = [];
    
    for (const menu of this.currencyMeta.Menus) {
      for (const menuPack of menu.MenuPacks) {
        if (filteredMenuPackIds.includes(menuPack.Id)) {
          this.filteredMenuPacks.push(menuPack);
        }
      }
    }

    this.logService.debug("upgrade time purchase", this.purchase);
    if(this.purchase && this.purchase.Items.length > 0)
    {
      for(const item of this.purchase.Items)
      {
        for (const menu of this.currencyMeta.Menus) {
          this.selectedMenuPack = menu.MenuPacks.find(cc => cc.Id === item.Id) as MenuPack;
          if(typeof this.selectedMenuPack != "undefined")
          {
            this.selectedMenuPackId = this.selectedMenuPack.Id;
            this.pack = this.currencyMeta.Packs.find(p => p.Id === this.selectedMenuPack.PackId);
            break;
          }
        }
      }

      var booking: Booking = this.myDrop.Subscriptions.find(c => c.CurrencyId == this.selectedMenuPack?.CurrencyId && c.Action != MembershipAction.Canceled) as Booking;
      if(booking && booking.Id > 0)
      {
        this.nextChargableDate = booking.NextChargableDate;
      }
    }
    this.initialized = true;
  }

  ngAfterViewInit() {
    // Find the pack-image element using ElementRef
    const packImage = this.elRef.nativeElement.querySelector('.pack-image img');

    if (packImage) {
      // Listen for the 'load' event on the image element
      packImage.addEventListener('load', () => {
        // Find the container element
        const container = document.querySelector('.modal-dialog');

        if (container) {
          // Calculate the dynamic height of modal-body
          const containerHeight = container.clientHeight;
          const headerHeight = document.querySelector('.modal-header')?.clientHeight || 0;
          const packImageHeight = document.querySelector('.pack-image')?.clientHeight || 0; 
          const footerHeight = document.querySelector('.modal-footer')?.clientHeight || 0;
          this.modalBodyHeight = containerHeight - headerHeight - footerHeight;
        }
        // You can also set the modal-body height using Renderer2
        this.renderer.setStyle(this.elRef.nativeElement.querySelector('.modal-body'), 'height', this.modalBodyHeight + 'px');
      });
    }
  }

  openCheckoutPopup() {
    setTimeout(() => {
      const booking: Booking = this.myDrop?.Subscriptions?.find(
        c => c.CurrencyId == this.selectedMenuPack?.CurrencyId && c.Action != MembershipAction.Canceled
      ) as Booking;

      const startAt = upgradeTimeStartCalendarDate({
        upgradeNow: this.selectedUpgradeNow,
        nextChargableDate: this.nextChargableDate,
        facilityTimeZone: Utils.resolveSessionTimeZone(this.environmentService.getFacilityConfig()?.timezone),
      });

      // DFS-2020: TransitionV2 needs BookingId + StartAt (today vs next cycle).
      if (booking && booking.Id > 0) {
        this.purchase.BookingId = booking.Id;
      }
      this.purchase.StartAt = startAt;
      if (this.selectedMenuPackId > 0) {
        this.purchase.MainItemId = this.selectedMenuPackId;
        const item = this.purchase.Items?.find(i => i.Id > 0);
        if (item) {
          item.Id = this.selectedMenuPackId;
        }
      }

      const modalRef = this.modalService.open(this.checkoutComponent, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'lg',
        centered: false,
        windowClass: 'checkout-popup-wrapper',
        modalDialogClass: 'checkout-popup',
        fullscreen: window.innerWidth <= 768,
      });

      modalRef.componentInstance.purchase = this.purchase;
      modalRef.componentInstance.currencyMeta = this.currencyMeta;
      modalRef.componentInstance.myDrop = this.myDrop;

      modalRef.result.then((result: boolean) => {
        this.logService.debug("choose plan:", result);
        this.closeModal(result);
      });
    }, 1000);
  }
  getTermDuration(menuPackId: number) {
    const menuPack = this.filteredMenuPacks.find(mp => mp.Id === menuPackId);
    if(menuPack)
    {
      return "per " + Utils.getEnumNameFromValue(TermUnit, menuPack.TermUnit).toLowerCase();
    }
    return "";
  }

  getTermUnitText(menuPackId: number) {
    const menuPack = this.filteredMenuPacks.find(mp => mp.Id === menuPackId);
    if(menuPack)
    {
      return Utils.getEnumNameFromValue(TermUnit, menuPack.TermUnit).toUpperCase() + "LY";
    }
    return "";
  }

  getNextChargableDate(date: string) : string
  {
    if(date)
    {
      // Parse the input date
      const parsedDate = moment(date, 'YYYY-MM-DD');
      // Format the parsed date in the desired format
      return parsedDate.format('MMM DD, YYYY');
    }
    return "";
  }

  changeTiming(upgradeNow: boolean) {
    this.selectedUpgradeNow = upgradeNow;
    this.selectedUpgradeNowStr = this.selectedUpgradeNow ? "true" : "false";
  }

  closeModal(result: boolean) {
    this.passEntry.emit(result);
    this.activeModal.close(result);
  }

  toUpperCase(text: string | undefined)
  {
    return text?.toUpperCase();
  }

  ngOnDestroy(): void {
    this._unsubscribe.next(null);
    this._unsubscribe.complete();
  }
}